import React from 'react';
import Skills from './Skills.js';
import Tilt from 'react-parallax-tilt';
import Lottie from "lottie-react"
import Coder from '../LottieFiles/coder.json';

const About = () => {
  return (
    <>
      <div className='AboutPage'>
        <div className='AboutText'>
          <h1 className='AboutTextHeading' >Get to <b>know</b> me!</h1>
          <p>
            Hi, my name is <b>Omkar Ghongade</b> and I am from Pune, India.
            I'm a <b>Full Stack Web Developer</b> and a final year student pursuing <b>B.Tech in CSE</b>. <br/><br/>
            I have done an internship as a <b>software developer</b> at Fidelity Investments.
            I love to develop unique projects which will be helpfull. I am currently building a <b>MicroSaaS</b><br/><br/>
            With my eyes set on the future, I am on the lookout for <b>opportunities to collaborate</b> with like-minded individuals and businesses who share my passion for technology. Let's <b>connect</b> and build something amazing together!
          </p>
        </div>

        <div>
          <Tilt>
              <Lottie 
              className="illustration" 
              animationData={Coder} 
              loop={true} 
            />
          </Tilt>
        </div>

      </div>
      
      <h1 className='SkillsHeading'>Technical Skills</h1>
      <div className='skills'>
        <Skills skill='python'/>
        <Skills skill='cpp'/>
        <Skills skill='java'/>
        <Skills skill='javascript'/>
        <Skills skill='Latex'/>
        <Skills skill='angular'/>
        <Skills skill='react'/>
        <Skills skill='node'/>
        <Skills skill='flask'/>
        <Skills skill='django'/>
        <Skills skill='android'/>
        <Skills skill='mysql'/>
        <Skills skill='postgresql'/>
        <Skills skill='mongodb'/>
        <Skills skill='aws'/>
        <Skills skill='gcloud'/>
        <Skills skill='git'/>
        <Skills skill='github'/>
        <Skills skill='notion'/>
        <Skills skill='postman'/>
        <Skills skill='docker'/>
        <Skills skill='firebase'/>
      </div>
    </>
  )
}

export default About